import { render, staticRenderFns } from "./LoginComponentSubmitButton.vue?vue&type=template&id=9134fb94"
import script from "./LoginComponentSubmitButton.vue?vue&type=script&lang=ts"
export * from "./LoginComponentSubmitButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports